// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentModeType$OrcaPaymentPage from "../Types/PaymentModeType.bs.js";

function InfoElement(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var selectedOption = PaymentModeType$OrcaPaymentPage.paymentMode(Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom));
  var displayText;
  switch (selectedOption) {
    case "ACHTransfer" :
    case "SepaTransfer" :
    case "InstantTransfer" :
    case "InstantTransferFinland" :
    case "InstantTransferPoland" :
    case "BacsTransfer" :
    case "Boleto" :
        displayText = localeString.bankDetailsText;
        break;
    default:
      displayText = localeString.redirectText;
  }
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: match$1.redirectionInfo === "ShowRedirectionInfo",
              children: React.createElement("div", {
                    className: "InfoElement flex flex-row w-full pr-3 gap-3",
                    style: {
                      color: themeObj.colorText,
                      fontSize: themeObj.fontSizeLg,
                      fontWeight: themeObj.fontWeightLight,
                      opacity: "60%"
                    }
                  }, React.createElement("div", undefined, React.createElement(Icon$OrcaPaymentPage.make, {
                            name: "redirect",
                            size: 55,
                            shouldMirrorIcon: localeString.localeDirection === "rtl"
                          })), React.createElement("div", {
                        className: "self-center"
                      }, displayText))
            });
}

var make = InfoElement;

export {
  make ,
}
/* react Not a pure module */
